<!-- Общая выбираемая карточка записи; действия отделены от кнопки открытия. -->
<template>
  <article :style="{ '--record-selected-color': selectedColor }" class="record-list-card__item" :class="{ 'record-list-card__item--selected': selected, 'record-list-card__item--archived': archived }" @click="select">
    <div class="record-list-card__header"><slot name="badges" /><slot name="status" /></div>
    <button type="button" class="record-list-card__open" :aria-pressed="selected" @click.stop="select">
      <strong>{{ title }}</strong>
      <span v-if="description" class="record-list-card__text">{{ description }}</span>
      <span class="record-list-card__meta"><slot name="meta" /></span>
      <span v-if="$slots.result" class="record-list-card__resolved"><slot name="result" /></span>
    </button>
  </article>
</template>
<script>
export default {
  name: "RecordListSelectableCard",
  props: {
    title: { type: String, required: true }, description: { type: String, default: "" },
    selectedColor: { type: String, default: "var(--color-blue)" },
    selected: { type: Boolean, default: false }, archived: { type: Boolean, default: false },
  },
  emits: ["update:selected", "select"],
  methods: {
    async select() {
      this.$emit("update:selected", true);
      // Модалка должна открываться после обновления выделения в DOM,
      // а не только после изменения selectedId в родителе.
      await this.$nextTick();
      this.$emit("select");
    },
  },
};
</script>
<style scoped>.record-list-card__item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px;
  width: 100%;
  text-align: left;
  border: 1px solid #e5e9ef;
  border-radius: 10px;
  background: white;
  cursor: pointer;
  font: inherit;
  color: inherit;
}
.record-list-card__item:hover {
  border-color: #a5b4d2;
}
.record-list-card__item--selected {
  border-color: var(--record-selected-color);
  box-shadow: inset 3px 0 var(--record-selected-color);
  background: #f8faff;
}
.record-list-card__open:focus-visible {
  outline: 2px solid var(--color-blue);
  outline-offset: 2px;
}
.record-list-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.record-list-card__open {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.record-list-card__item strong {
  overflow-wrap: anywhere;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
}
.record-list-card__text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 1.5;
}
.record-list-card__meta,
.record-list-card__resolved {
  font-size: 12px;
  line-height: 1.4;
  color: #64748b;
}
.record-list-card__resolved {
  color: #147653;
}

.record-list-card__item--archived { border-style: dashed; background: #f1f5f9; }
</style>
